import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { motion, AnimatePresence } from "motion/react";

import TPPanelSkeleton from "./TPPanelSkeleton";
import TPSection from "./TPSection";
import OrganizacionSection from "./OrganizacionSection";
import ObjetivosSection from "./ObjetivosSection";
import { TabIndex } from "./CurriculumTabsABPHeader";
import { useCurriculumTabsABPContentHandlers } from "./useCurriculumTabsABPContentHandlers";

type Especialidad = { id: string; nombre: string };
type SimpleIdNombre = { id: string; nombre: string };

interface Props {
  tabValue: TabIndex;
  isLoadingTPInfo: boolean;
  allowedTP: boolean;

  isTecnicoProfesional: boolean;
  isOrganizacion: boolean;

  // TP
  especialidadId: string;
  setEspecialidad: React.Dispatch<React.SetStateAction<Especialidad | null>>;
  clearTP: () => void;
  nivelTPId: string;
  asignaturaTPId: string;
  handleNivelTPChange: (nivel: any) => void;
  handleAsignaturaTPChangeLocal: (a: { id: string; nombre: string }) => void;

  // ORG
  nivelOrg: SimpleIdNombre;
  setNivelOrg: React.Dispatch<React.SetStateAction<SimpleIdNombre>>;
  asignaturaOrg: SimpleIdNombre;
  setAsignaturaOrg: React.Dispatch<React.SetStateAction<SimpleIdNombre>>;
  emptyIdNombre: SimpleIdNombre;

  // CN
  nivelId: any;
  handleNivelChangeABP: any;
  selectedAsignatura: any;
  setSelectedAsignatura: any;
  handleAsignaturaChangeLocalABP: any;

  // shared
  promptData: any;
  setPromptData: React.Dispatch<React.SetStateAction<any>>;

  objetivosSeleccionados: any;
  setObjetivosSeleccionados: React.Dispatch<React.SetStateAction<any>>;
  setIsOAAdded: React.Dispatch<React.SetStateAction<boolean>>;

  setProyecto: React.Dispatch<React.SetStateAction<any>>;
  borderColor: string;
}

export default function CurriculumTabsABPContent({
  tabValue,
  isLoadingTPInfo,
  isTecnicoProfesional,
  isOrganizacion,

  especialidadId,
  setEspecialidad,
  clearTP,
  nivelTPId,
  asignaturaTPId,
  handleNivelTPChange,
  handleAsignaturaTPChangeLocal,

  nivelOrg,
  setNivelOrg,
  asignaturaOrg,
  setAsignaturaOrg,
  emptyIdNombre,

  nivelId,
  handleNivelChangeABP,
  selectedAsignatura,
  setSelectedAsignatura,
  handleAsignaturaChangeLocalABP,

  promptData,
  setPromptData,

  objetivosSeleccionados,
  setObjetivosSeleccionados,
  setIsOAAdded,

  setProyecto,
  borderColor,
}: Props) {
  const [asignaturaSeleccionadaTP, setAsignaturaSeleccionadaTP] =
    useState<SimpleIdNombre | null>(null);

  const handlers = useCurriculumTabsABPContentHandlers({
    setEspecialidad,
    clearTP,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    setNivelOrg,
    setAsignaturaOrg,
    emptyIdNombre,
    setPromptData,
    setProyecto,
  });

  const showSkeleton = isTecnicoProfesional && isLoadingTPInfo;
 // const showBody = !isLoadingTPInfo;

  const mode: "TP" | "ORG" | "CN" = isTecnicoProfesional
    ? "TP"
    : isOrganizacion
    ? "ORG"
    : "CN";

  
  useEffect(() => {
    setAsignaturaSeleccionadaTP(null);
  }, [especialidadId, nivelTPId]);


  const handleTPAsignaturaChange = (a: { id: string; nombre: string }) => {
    setAsignaturaSeleccionadaTP({ id: a.id, nombre: a.nombre });
    handlers.onTPAsignaturaChange(a);
  };

  return (
    <Box
      sx={{
        p: 3,
        border: `1px solid ${borderColor}`,
        borderTop: "none",
        borderRadius: "0 0 16px 16px",
        overflow: "hidden",
      }}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={tabValue}
          initial={{ opacity: 0, x: 12 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -12 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
        >
          <Grid container spacing={2}>
            <TPPanelSkeleton show={showSkeleton} />

            
              <>
                {mode === "TP" && (
                  <TPSection
                    especialidadId={especialidadId}
                    nivelTPId={nivelTPId}
                    asignaturaTPId={asignaturaTPId}
                    onEspecialidadChange={handlers.onEspecialidadChange}
                    onNivelChange={handlers.onTPNivelChange}
                    onAsignaturaChange={handleTPAsignaturaChange}
                  />
                )}

                {mode === "ORG" && (
                  <OrganizacionSection
                    nivelOrg={nivelOrg}
                    asignaturaOrg={asignaturaOrg}
                    onNivelChange={handlers.onOrgNivelChange}
                    onAsignaturaChange={handlers.onOrgAsignaturaChange}
                  />
                )}

                <ObjetivosSection
                  mode={mode}
                  especialidadId={especialidadId}
                  nivelTPId={nivelTPId}
                  asignaturaSeleccionadaTP={asignaturaSeleccionadaTP}
                  nivelOrg={nivelOrg}
                  asignaturaOrg={asignaturaOrg}
                  nivelId={nivelId}
                  handleNivelChangeABP={handleNivelChangeABP}
                  selectedAsignatura={selectedAsignatura}
                  setSelectedAsignatura={setSelectedAsignatura}
                  handleAsignaturaChangeLocalABP={handleAsignaturaChangeLocalABP}
                  promptData={promptData}
                  setPromptData={setPromptData}
                  objetivosSeleccionados={objetivosSeleccionados}
                  setObjetivosSeleccionados={setObjetivosSeleccionados}
                  setIsOAAdded={setIsOAAdded}
                />
              </>
           
          </Grid>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
}
